// extracted by mini-css-extract-plugin
export default {"modalButtons":"styles_modalButtons__t9rE5"};